import { render, staticRenderFns } from "./sup-deposit-crypto.vue?vue&type=template&id=163add02"
import script from "./sup-deposit-crypto.vue?vue&type=script&lang=js"
export * from "./sup-deposit-crypto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports